import { render } from "./cardsprods2.vue?vue&type=template&id=b1161552&scoped=true"
import script from "./cardsprods2.vue?vue&type=script&lang=js"
export * from "./cardsprods2.vue?vue&type=script&lang=js"

import "./cardsprods2.vue?vue&type=style&index=0&id=b1161552&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1161552"]])

export default __exports__